module.exports = __webpack_public_path__ + "static/team-hero-8579abad7efba626f23889c84702177d.png";